<div *ngIf="previewImages.length > 0" class="preview-container">
  <div class="preview-image-wrapper" *ngFor="let image of previewImages; let i = index">
    <div *ngIf="image.status === 'uploading'" class="preview-loading">
      <div class="loading-wheel">
        <kmd-loading-wheel></kmd-loading-wheel>
      </div>
    </div>
  </div>
</div>
